export const formatPlanDuration = (days) => {
    if (!days) return "";

    const durationMap = {
        7: "Weekly",
        30: "Monthly",
        90: "Quarterly",
        180: "Half-Yearly",
        365: "Yearly",
    };

    if (durationMap[days]) return durationMap[days];

    // fallback
    if (days < 30) return `${days} Days`;
    if (days % 30 === 0) return `${days / 30} Months`;

    return `${days} Days`;
};
